class ContainerCollectionSidebar extends HTMLElement {
  #events;

  connectedCallback() {
    this.#events?.abort();
    this.#events = new AbortController();
    const button = this.querySelector('.tcg-sidebar__toggle');
    const desktop = window.matchMedia('(min-width: 990px)');
    const setExpanded = (expanded) => {
      this.toggleAttribute('data-expanded', expanded);
      button.setAttribute('aria-expanded', String(expanded));
    };
    setExpanded(desktop.matches);
    this.dataset.enhanced = '';
    button.addEventListener('click', () => setExpanded(!this.hasAttribute('data-expanded')), {signal:this.#events.signal});
    desktop.addEventListener('change', (event) => setExpanded(event.matches), {signal:this.#events.signal});
  }

  disconnectedCallback() {
    this.#events?.abort();
  }
}

if (!customElements.get('tcg-collection-sidebar')) customElements.define('tcg-collection-sidebar', ContainerCollectionSidebar);
